/* eslint camelcase: 0 */

import { NotificationBanner as Data } from '@/typings/api/NotificationBanner'
import { Model, createMessages } from '@/helpers/Model'


export class NotificationBannerModel extends Model<Data> {
  public static readonly page_title = createMessages({
    create: 'Добавить баннер',
    edit: 'Редактировать баннер',
    view: (data: NotificationBannerModel) => 'Баннер «{name}»'
      .replace('{name}', data.name || '...'),
    list: 'Баннеры',
  });

  public static readonly modal_delete = createMessages({
    delete: (data: NotificationBannerModel) => 'Удаление баннера «{name}»'
      .replace('{name}', data.name || '...'),
    delete_all: 'Удаление выбранных баннеров',
    delete_all_partly: 'Удаление части выбранных баннеров',
  });

  public static readonly response_success = createMessages({
    ...Model.response_success,
    delete_all_deny: 'Выбранные баннера нельзя удалить',
  });

  public static readonly response_error = createMessages({
    ...Model.response_error,
  });

  public static getActiveLabel(data: Data) {
    return data.is_active
      ? 'Активный'
      : 'Заблокирован'
  }

  public static getName(data: Data): string {
    return data?.body && `${data.body.slice(0, 30).replace(/<\/?[^>]+(>|$)/g, '')}...`
  }
}
